module.exports = __webpack_public_path__ + "img/preferential-bg.12e5e8d3.png";